import { useMemo } from 'react';

import { CoveringContractsTable } from '~/components/invoices/detailPage/related/ContractsSection';
import { selectContractsCoveringCars } from '~/components/invoices/detailPage/related/coveringContracts';
import type { TaskDetail } from '~/data/generated/model';
import { useContractsForProperty } from '~/data/hooks/useContracts';
import { useLocaleTerms } from '~/hooks/useLocaleTerms';

export function useTaskContracts(task: TaskDetail) {
  const { contracts, isLoading } = useContractsForProperty(task.propertyId);
  const covering = useMemo(
    () =>
      selectContractsCoveringCars(contracts, {
        propertyId: task.propertyId,
        carIds: task.cars.map((car) => car.id),
        wholeProperty: task.cars.length === 0,
      }),
    [contracts, task.propertyId, task.cars],
  );
  return { covering, isLoading };
}

export function TaskContractsTab({ task }: { task: TaskDetail }) {
  const terms = useLocaleTerms();
  const { covering, isLoading } = useTaskContracts(task);
  return (
    <CoveringContractsTable
      covering={covering}
      isLoading={isLoading}
      noCoverageLabel={`None of this task's ${terms.vehicles.toLowerCase()}`}
      previewList="elevator_contracts"
      emptyMessage={
        task.cars.length === 0
          ? 'No contract is on file for this property.'
          : `No contract covers the ${terms.vehicles.toLowerCase()} on this task.`
      }
    />
  );
}
